const styles = theme => ({
  drawerHeader:{
    height:108,
  },
  textFontSize: {
    fontSize: 12.5,
  },
  backgroundProperties: {
    background: 'rgba(255, 255, 255, 1.0)',
  },
  card: {
    width:218,
    height:59.78,
    marginTop:38,
    background: 'rgba(243, 243, 243, 0.5)',
    boxShadow: '0 0px 0px 0px rgba(0, 0, 0, 0)',
    position: 'fixed',
    borderRadius:4,
  },
  cardDetails: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor:'red',
    width:180,
  },
  cardContent: {
    flex: '1 0 auto',
    marginLeft: 45,
    marginTop: -50,
    width:100,
    height:20
  },
  cardCover: {
    marginLeft: 10,
    marginTop: 10,
    width: 40,
    height: 40,
    borderRadius: 20,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/SideDrawer/components/DrawerMenu/components/Header/styles.js